'use client';
import React from 'react';

interface Channel {
  name: string;
  category: string;
  color: string;
  textColor: string;
  featured?: boolean;
}

const channels: Channel[] = [
  { name: 'ESPN', category: 'Sports', color: '#cc0000', textColor: '#fff', featured: true },
  { name: 'CNN', category: 'News', color: '#cc0000', textColor: '#fff', featured: true },
  { name: 'TNT', category: 'Entertainment', color: '#0033cc', textColor: '#fff', featured: true },
  { name: 'FOX NEWS', category: 'News', color: '#003366', textColor: '#fff', featured: true },
  { name: 'TBS', category: 'Entertainment', color: '#cc6600', textColor: '#fff', featured: true },
  { name: 'FX', category: 'Entertainment', color: '#111', textColor: '#fff', featured: true },
  { name: 'A&E', category: 'Entertainment', color: '#333', textColor: '#fff' },
  { name: 'BRAVO', category: 'Entertainment', color: '#cc0066', textColor: '#fff' },
  { name: 'TLC', category: 'Lifestyle', color: '#0099cc', textColor: '#fff' },
  { name: 'HGTV', category: 'Lifestyle', color: '#006633', textColor: '#fff' },
  { name: 'FOOD', category: 'Lifestyle', color: '#ff6600', textColor: '#fff' },
  { name: 'USA', category: 'Entertainment', color: '#003399', textColor: '#fff' },
  { name: 'MSNBC', category: 'News', color: '#0066cc', textColor: '#fff' },
  { name: 'SYFY', category: 'Entertainment', color: '#ffcc00', textColor: '#000' },
  { name: 'E!', category: 'Entertainment', color: '#cc0099', textColor: '#fff' },
  { name: 'DISNEY', category: 'Family', color: '#003399', textColor: '#fff' },
  { name: 'NICK', category: 'Family', color: '#ff6600', textColor: '#fff' },
  { name: 'CARTOON', category: 'Family', color: '#cc0000', textColor: '#fff' },
  { name: 'HISTORY', category: 'Documentary', color: '#333', textColor: '#fff' },
  { name: 'NATGEO', category: 'Documentary', color: '#ffcc00', textColor: '#000' },
  { name: '+ MORE', category: '', color: '#20222f', textColor: '#00b9ff' },
];

export default function ChannelsSection() {
  return (
    <section className="py-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="section-card p-8 sm:p-12 flex flex-col lg:flex-row items-center gap-10">
          {/* Left text */}
          <div className="lg:w-2/5 flex-shrink-0">
            <h2 className="text-[28px] sm:text-[32px] font-black text-white mb-4 leading-tight">
              We Have Your{' '}
              <span className="text-gradient-blue">Favorite Channels</span>
            </h2>
            <p className="text-[#979797] text-base leading-relaxed mb-6">
              Choose the channels you love to watch and we&apos;ll recommend the best Sling Consonantal Digital plan for you.
            </p>
            <a href="#" className="btn-outline-blue inline-flex">
              Shop for Channels
            </a>
          </div>

          {/* Right channel grid */}
          <div className="flex-1 w-full">
            <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-7 gap-2">
              {channels.map((ch, i) => (
                <div
                  key={i}
                  className="channel-logo text-xs font-black text-center py-3 px-2 cursor-pointer"
                  style={{
                    backgroundColor: ch.color,
                    color: ch.textColor,
                    border: ch.name === '+ MORE' ? '1px solid rgba(0,185,255,0.4)' : '1px solid rgba(255,255,255,0.1)',
                  }}
                >
                  {ch.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
